<template>
  <div>
    <p class="msg" style="margin: 0px;">
      <awesomeIcon icon="exclamation-circle" />
      {{ $parent.role === '2'
        ? `Uw klant heeft de offerte geaccepteerd. De onboarding, bestaande uit onze online
          vragenlijst, kan nu door u, uw klant of gezamenlijk worden ingevuld. Na het indienen
          hiervan zullen wij de rekeningaanvraag in behandeling nemen.`
        : 'Bezig met invullen vragenlijst'
      }}
    </p>
    <div class="card" v-if="$parent.intakes !== null">
      <div class="row menubar">
        <input
          type="text"
          v-model="search"
          ref="search"
          placeholder="Zoeken"
          @keyup="updateSearch"
          class="searchbar"
        />
        <!-- type sorting -->
        <div class="dropdown nowrap" style="float:right;">
          <button class="dropdown-button" @click="dropdownlist = !dropdownlist">
            <awesomeIcon icon="sort" /> {{ find(orders, {value: order }).label}}
          </button>
          <div
            class="dropdown-bg"
            v-if="dropdownlist"
            @click="dropdownlist = !dropdownlist"
          ></div>
          <ul class="dropdown-list" v-if="dropdownlist">
            <li
              v-for="(group) in orders"
              :key="group.value"
              @click="
                dropdownlist = !dropdownlist;
                chooseOrder(group.value);
              "
            >
              {{ group.label }}
            </li>
            <li class="dropdown-cancel" @click="dropdownlist = !dropdownlist">Annuleren</li>
          </ul>
        </div>
      </div>
      <table width="100%">
        <thead class="table-legend">
          <tr>
            <th>#</th>
            <th>Gebruiker</th>
            <th>Startbedrag</th>
            <th>Doeltype / Doelmeter</th>
            <th>Voortgang vragenlijst</th>
            <th></th>
          </tr>
        </thead>
        <tr>
          <td colspan="6" style="padding: 0px;">
            <p class="msg" style="margin: 0px;">
              <awesomeIcon class="secondary" icon="exclamation-circle" />
              Door op '<awesomeIcon icon="search"/> Bekijk' te klikken gaat u naar de omgeving van
              uw klant en komt u direct bij de vragenlijst.  Om weer terug te keren, klikt u eerst
              op 'Verlaat vragenlijst' en vervolgens op 'Uitloggen'.
            </p>
          </td>
        </tr>
        <tr v-for="(client, index) in slice(
            filter(sortBy(intakeClients, order), searchFilter),
            currentPage * resultsPerPage, (
              currentPage + 1
            ) * resultsPerPage
          )"
          :key='`client${index}intake${client.intake.id}`'
        >
          <td class="grey concat"> {{client.intake.id}} </td>
          <td v-if="$parent.role === '2' && client.intake.intakeData.companyName">
            <span class="concat" :title="`Naam bedrijf: ${client.intake.intakeData.companyName}`">
              {{client.intake.intakeData.companyName}}
            </span><br />
            <span class="grey concat" :title="`Naam: ${client.intake.intakeData.combinedName}`">
              {{client.intake.intakeData.combinedName}}
            </span><br />
            <span class="grey concat" :title="client.email">{{ client.email }}</span>
          </td>
          <td v-else>
            {{
              client.intake.intakeData.combinedName
                ? client.intake.intakeData.combinedName
                : '-'
            }} <br />
            <span class="grey concat" :title="client.email">{{ client.email }}</span>
          </td>
          <td>
            Startbedrag:
            <span class="grey concat">
              €
              {{
                client.intake.intakeData.goalData
                && client.intake.intakeData.goalData.vermogen
                  ? formatPrice(client.intake.intakeData.goalData.vermogen, true)
                  : '-'
              }}
            </span>
          </td>
          <td>
            Doeltype:
            <span class="grey concat">
              {{
                client.intake.intakeData && client.intake.intakeData.goalData
                ? ($parent.role === '2'
                    ? $parent.typeToATPGoal(client.intake.intakeData.goalData)
                    : typeToGoal(client.intake.intakeData.goalData)
                  )
                : '-'
              }}
            </span><br />
            Doelmeter:
            <span class="grey concat">
              {{ client.intake.intakeData
                && client.intake.intakeData.goalData
                && client.intake.intakeData.goalData.score
              ? `${formatPrice(client.intake.intakeData.goalData.score, true)}%`
              : '-'}}
            </span><br />
          </td>
          <td>
            Voortgang:
            <span class="grey concat">
              {{
              client.intake.intakeData
              && client.intake.intakeData.progress
              ? `${formatPrice(client.intake.intakeData.progress, true)}%`
              : '-'}}
            </span>
          </td>
          <td style="float:right;">
            <button
              @click="$parent.becomeUser(client.client, client.intake.id)"
              class="secondary hide-mobile"
              style="padding-top: 10px;"
            >
              <awesomeIcon icon="search"/> Bekijk
            </button>
          </td>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="filter(intakeClients, searchFilter).length"
        :resultsPerPage="resultsPerPage"
      />
    </div>
  </div>
</template>

<script>
import {
  filter, find, slice, sortBy, cloneDeep,
} from 'lodash-es';

export default {
  name: 'OnboardingIntake',
  data() {
    return {
      search: '',
      order: 'name',
      orders: [
        { label: 'Intake', value: 'intake.id' },
        { label: 'Naam', value: 'name' },
        { label: 'Email', value: 'email' },
        { label: 'Startbedrag', value: 'intake.intakeData.goalData.vermogen' },
        { label: 'Doeltype', value: 'intake.intakeData.goalData' },
        { label: 'Doelmeter', value: 'intake.intakeData.goalData.score' },
        { label: 'Intake Voortgang', value: 'intake.progressRev' },
      ],
      dropdownlist: false,
      currentPage: 0,
      resultsPerPage: 10,
    };
  },
  computed: {
    intakeClients() {
      const temp = [];
      for (let i = 0; i < this.$parent.intakes.length; i += 1) {
        for (let j = 0; j < this.$parent.intakes[i].intakes.length; j += 1) {
          const tempObj = cloneDeep(this.$parent.intakes[i]);
          tempObj.type = 'intake';
          tempObj.intake = tempObj.intakes[j];
          if (this.$parent.role === '2'
            && tempObj.intake.intakeData.rekeningData
            && tempObj.intake.intakeData.goalData
            && tempObj.intake.intakeData.rekeningData.type === 'Bedrijfsrekening'
            && tempObj.intake.intakeData.goalData.type === 'vermogensopbouw') {
            tempObj.intake.intakeData.goalData.goal = 'Bedrijfsrekening';
            tempObj.intake.intakeData.companyName = tempObj.intake.intakeData.bedrijfsData.bedrijfsnaam || '';
          } else if (tempObj.intake.intakeData.goalData) {
            tempObj.intake.intakeData.goalData.goal = tempObj.intake.intakeData.goalData.type;
          }

          tempObj.intake.intakeData.combinedName = '';
          if (tempObj.intake.intakeData.persoonsData && tempObj.intake.intakeData.persoonsData[0]) {
            let firstName = '';
            if (tempObj.intake.intakeData.persoonsData[0].roepnaam) {
              firstName = tempObj.intake.intakeData.persoonsData[0].roepnaam;
            } else if (tempObj.intake.intakeData.persoonsData[0].voorletters) {
              firstName = tempObj.intake.intakeData.persoonsData[0].voorletters;
            } else if (tempObj.intake.intakeData.persoonsData[0].voornaam) {
              firstName = tempObj.intake.intakeData.persoonsData[0].voornaam;
            }
            tempObj.intake.intakeData.combinedName = `${firstName} ${tempObj.intake.intakeData.persoonsData[0].tussenvoegsel || ''} ${tempObj.intake.intakeData.persoonsData[0].achternaam || ''}`;
          }
          tempObj.intake.progressRev = 100 - Number(tempObj.intake.intakeData.progress || 0);
          delete tempObj.intakes;
          temp.push(tempObj);
        }
      }
      return temp;
    },
  },
  methods: {
    filter,
    find,
    slice,
    sortBy,
    typeToGoal(data) {
      if (data.type === 'studiekinderen') {
        return 'studie kinderen';
      }
      if (data.type === 'groteaankoop') {
        return 'grote aankoop';
      }
      if (data.type === 'gouden-handdruk-opbouwend') {
        return 'gouden handdruk (opbouwend)';
      }
      if (data.type === 'gouden-handdruk-uitkerend') {
        return 'gouden handdruk (uitkerend)';
      }
      if (data.type === 'netto-lijfrente-uitkerend') {
        return 'Netto lijfrente (uitkerend)';
      }
      if (data.type === 'netto-lijfrente-opbouwend') {
        return 'Netto lijfrente (opbouwend)';
      }
      if (data.type === 'pensioen' && data.box === '1') {
        return 'pensioen (box 1)';
      }
      if (data.type === 'levensonderhoud'
        && data.box === '1') {
        return 'leefrente (box 1)';
      }
      return data.type;
    },
    chooseOrder(group) {
      this.dropdownlist = false;
      this.order = group;
    },
    updateSearch() {
      this.currentPage = 0;
      this.search = this.$refs.search.value.toLowerCase();
    },
    searchFilter(obj) {
      const trimmedSearch = this.search.trim();
      if (obj.name.toLowerCase().indexOf(trimmedSearch) > -1) {
        return true;
      }
      if (obj.email.toLowerCase().indexOf(trimmedSearch) > -1) {
        return true;
      }
      if (String(obj.intake.id).indexOf(trimmedSearch) > -1) {
        return true;
      }
      if (this.$parent.role === '2' && this.$parent.typeToATPGoal(
        obj.intake.intakeData.goalData,
      ).toLowerCase().indexOf(trimmedSearch) > -1) {
        return true;
      }
      if (this.$parent.role !== '2' && this.typeToGoal(
        obj.intake.intakeData.goalData,
      ).toLowerCase().indexOf(trimmedSearch) > -1) {
        return true;
      }
      if (this.formatPrice(
        obj.intake.intakeData.goalData.score,
        true,
      ).indexOf(trimmedSearch) > -1) {
        return true;
      }
      if (this.formatPrice(
        obj.intake.intakeData.progress,
        true,
      ).indexOf(trimmedSearch) > -1) {
        return true;
      }
      if (obj.intake.intakeData.goalData
        && obj.intake.intakeData.goalData.vermogen.indexOf(trimmedSearch) > -1) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
